import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const Header = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.open(
        `https://us.rs-online.com/web/c/?searchTerm=${encodeURIComponent(searchQuery.trim())}`,
        '_blank',
        'noopener,noreferrer'
      );
    }
  };

  return (
    <header className="w-full bg-white font-sans select-none border-b border-gray-200">
      {/* Top Maroon Notification / Region Bar */}
      <div className="bg-[#4A1525] text-white py-1.5 px-4 sm:px-8">
        <div className="max-w-7xl mx-auto flex justify-end items-center space-x-6 text-xs font-normal">
          <div className="flex items-center space-x-1 cursor-pointer hover:underline">
            <span>USA - ENG</span>
            <svg
              className="w-3.5 h-3.5 text-white inline-block"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <a href="#expert-advice" className="text-white hover:underline">
            Expert Advice
          </a>
          <a href="#customer-support" className="text-white hover:underline">
            Customer Support
          </a>
        </div>
      </div>

      {/* Main Bar: RS Logo, Search, User, Cart */}
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex items-center justify-between gap-4">
        {/* RS Logo */}
        <Link to="/" className="flex-shrink-0 flex items-center">
          <img
            src={logo}
            alt="RS"
            className="h-10 w-10 sm:h-11 sm:w-11 object-contain rounded-[2px]"
          />
        </Link>

        {/* Search Bar */}
        <div className="flex-1 max-w-2xl mx-2 sm:mx-8">
          <form id="header-search-form" onSubmit={handleSearch} className="relative flex items-center">
            <input
              id="header-search-input"
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search by keyword or item number"
              className="w-full h-10 pl-3 pr-10 border border-gray-400 rounded-none text-sm text-gray-800 placeholder:italic placeholder:text-gray-500 focus:outline-none focus:border-gray-700"
            />
            <button
              id="header-search-submit-button"
              type="submit"
              className="absolute right-0 top-0 bottom-0 px-3 flex items-center justify-center text-gray-600 hover:text-black focus:outline-none"
              aria-label="Search"
            >
              <svg
                className="w-4 h-4 text-gray-700"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </button>
          </form>
        </div>

        {/* User Login & Cart */}
        <div className="flex items-center space-x-6 flex-shrink-0 text-sm">
          <Link
            to="/login"
            className="flex items-center space-x-2 text-gray-900 font-semibold hover:text-[#2A437E] transition-colors"
          >
            <svg
              className="w-5 h-5 text-gray-700"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.75"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            <span className="hidden sm:inline">Login / Signup</span>
          </Link>

          <div className="flex items-center space-x-2 text-gray-900 font-bold">
            <svg
              className="w-5 h-5 text-gray-800"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.75"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            <span>$0.00</span>
          </div>
        </div>
      </div>

      {/* Sub-Navigation Categories Bar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-8 pb-3 pt-1 flex items-center space-x-8 text-sm font-semibold text-gray-900 overflow-x-auto">
        <button
          type="button"
          className="flex items-center space-x-1 hover:text-[#2A437E] whitespace-nowrap focus:outline-none"
        >
          <span>All Products</span>
          <svg
            className="w-3.5 h-3.5 text-gray-600"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <a
          href="#manufacturers"
          className="hover:text-[#2A437E] whitespace-nowrap"
        >
          Manufacturers
        </a>
        <button
          type="button"
          className="flex items-center space-x-1 hover:text-[#2A437E] whitespace-nowrap focus:outline-none"
        >
          <span>Services and Solutions</span>
          <svg
            className="w-3.5 h-3.5 text-gray-600"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <a
          href="#quick-order"
          className="hover:text-[#2A437E] whitespace-nowrap"
        >
          Quick Order
        </a>
      </div>
    </header>
  );
};

export default Header;
